import getLogger from '../../../../util/logger';
import sleep from '../../../../util/sleep';
import { photosUpload } from '../fileUpload/fileUploadActions';

const log = getLogger('contributorUploadsActions');
const DEFAULT_RETRY_ATTEMPT_SECONDS = 2;

export const CONTRIBUTOR_UPLOAD_REQUEST = 'contributor/UPLOAD_REQUEST';
export const CONTRIBUTOR_UPLOAD_COMPLETE = 'contributor/UPLOAD_COMPLETE';
export const CONTRIBUTOR_UPLOAD_PROGRESS = 'contributor/UPLOAD_PROGRESS';
export const CONTRIBUTOR_UPLOAD_RESET = 'contributor/UPLOAD_RESET';

const contributorUploadRequest = photos => {
  return { type: CONTRIBUTOR_UPLOAD_REQUEST, photos };
};

const contributorUploadComplete = () => {
  return { type: CONTRIBUTOR_UPLOAD_COMPLETE };
};

const contributorUploadProgress = uploadedPhoto => {
  return { type: CONTRIBUTOR_UPLOAD_PROGRESS, uploadedPhoto };
};

export const contributorUploadReset = () => {
  return { type: CONTRIBUTOR_UPLOAD_RESET };
};

const assignPhotosToAlbums = async ({
  photoIds,
  albums,
  albumAddPhotosMutation,
}) => {
  await Promise.all(
    albums.map(async album => {
      try {
        await albumAddPhotosMutation({
          albumId: album.id,
          photoGroupId: album.photoGroupId,
          photoIds,
        });
        return album.id;
      } catch (error) {
        log.error(error);
        // Force retry:
        await sleep(DEFAULT_RETRY_ATTEMPT_SECONDS * 1000);
        return assignPhotosToAlbums({
          photoIds,
          albums: [album],
          albumAddPhotosMutation,
        });
      }
    }),
  );
};

export const contributorUpload = ({
  photos,
  albums,
  photoBatchCreateMutation,
  photoBatchPhotosUploadMutation,
  photoBatchPhotosUpdateMutation,
  albumAddPhotosMutation,
}) => async (dispatch, getState) => {
  log.info('contributorUpload() :: Uploading photos...', photos);

  dispatch(contributorUploadRequest(photos));

  const uploadedPhotos = await photosUpload({
    photos,
    photoBatchCreateMutation,
    photoBatchPhotosUploadMutation,
    photoBatchPhotosUpdateMutation,
    onPhotoUploadProcessComplete: uploadedPhoto => {
      dispatch(contributorUploadProgress(uploadedPhoto));
    },
    dispatch,
    getState,
  });

  const successfullPhotosIds = uploadedPhotos
    .filter(({ photoId }) => !!photoId)
    .map(({ photoId }) => photoId);

  await assignPhotosToAlbums({
    photoIds: successfullPhotosIds,
    albums,
    albumAddPhotosMutation,
  });

  dispatch(contributorUploadComplete());
  log.info('contributorUpload() :: Upload finished');
};
